export enum MessageAck_ConfirmationType {
    markAsRead = "markAsRead",
    confirm = "confirm",
    markAsUnread = "markAsUnread"
    // delete? snooze?
} 
